import cn from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { isArray } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { alertClose } from '../../../store/actions/alert';
import SuccessIcon from './icons/SuccessIcon';
import ErrorIcon from './icons/ErrorIcon';
import CloseIcon from './icons/CloseIcon';

import styles from './AlertTemplate.module.scss';

const ALERT_CLOSE_AFTER = 15000;

export default function AlertTemplate() {
  const dispatch = useDispatch();
  const { messages } = useSelector((state) => state.alert);

  const timers = {};

  const startTimer = (messageId) => {
    const timerId = setTimeout(() => close(messageId), ALERT_CLOSE_AFTER);
    timers[messageId] = timerId;
  };

  const close = (messageId) => {
    dispatch(alertClose(messageId));
    clearTimeout(timers[messageId]);
    timers[messageId] = null;
  };

  return (
    <div className={styles.container}>
      <TransitionGroup>
        {messages.map((message) => {
          const { id: messageId, success, error, text, uppercase = true } = message;
          startTimer(messageId);

          let content = text;
          if (isArray(text)) {
            content = text.map((text, index) => <span key={index}>{text}</span>);
          }

          return (
            <CSSTransition key={messageId} timeout={400} classNames="fade">
              <div className={cn(styles.alert, success ? styles.success : '', uppercase ? styles.uppercase : '')}>
                {success && <SuccessIcon />}
                {error && <ErrorIcon />}
                <div className={styles.content}>{content}</div>

                <div className={styles.actions}>
                  <button onClick={() => close(messageId)}>
                    <CloseIcon />
                  </button>
                </div>
              </div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
}
